const CompletedIcon = ({ className, size = '28px' }) => (
  <div className={className}>
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
      <circle cx='12' cy='12' r='10' stroke='white' strokeWidth='2' fill='none' />
      <path
        d='M8 12.5l2.5 2.5 5.5-5.5'
        stroke='white'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </div>
);

export default CompletedIcon;
